import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { Toolbar, AppBar, Hidden, IconButton, Icon, Tooltip, Dialog, DialogContent, DialogTitle, Box, Typography, Button } from '@material-ui/core';
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton';
import UserMenu from 'app/fuse-layouts/shared-components/UserMenu';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import React, { useState, useEffect } from 'react';
import { selectToolbarTheme } from 'app/store/fuse/settingsSlice';
import FullScreenToggle from '../../shared-components/FullScreenToggle';
import LanguageSwitcher from '../../shared-components/LanguageSwitcher';
import LicenseNotificationBar from '../../shared-components/LicenseNotificationBar';
import LicenseType from '../../shared-components/LicenseType';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
    root: {}
}));

function ToolbarLayout1(props) {
    const dispatch = useDispatch();
    const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
    const user = useSelector(({ auth }) => auth.user);
    const isLoggedIn = useSelector(({ auth }) => auth.user.isLoggedIn);
    const userLicense = useSelector(({ auth }) => auth.user.userLicense);
    const [showNotificationToolbar, setShowNotificationToolbar] = useState(true);
    const toolbarTheme = useSelector(selectToolbarTheme);
    const { t } = useTranslation('fuse-layout');
    const classes = useStyles(props);
    const header = useSelector(({ fuse }) => fuse.header);
    const redirectPath = () => {
        let path = window.location.pathname;
        if (path.startsWith('/free')) path = path.substring('/free'.length);
        return path;
    }
    // const [showNewVersionDialog, setShowNewVersionDialog] = useState(false)

    useEffect(() => {
        let hideNotification = sessionStorage.getItem('hide-license-notification-bar')
        if (hideNotification && hideNotification == 'true') {
            setShowNotificationToolbar(false)
        } else {
            setShowNotificationToolbar(true)
        }
        // let hideNewVersionDialog = localStorage.getItem('hide-new-version-dialog')
        // if (hideNewVersionDialog && hideNewVersionDialog == 'true') {
        //     setShowNewVersionDialog(false)
        // } else {
        //     setShowNewVersionDialog(true)
        // }
    }, [dispatch]);

    // const handleDontShowVersionDialogAgain = () => {
    //     setShowNewVersionDialog(false)
    //     localStorage.setItem('hide-new-version-dialog', 'true')
    // }

    return (<>
        <ThemeProvider theme={toolbarTheme}>
            <AppBar
                id="fuse-toolbar"
                className={clsx(classes.root, 'flex relative z-10 shadow-md')}
                color="primary"
            // style={{ backgroundColor: toolbarTheme.palette.background.paper }}
            >
                {isLoggedIn && !user.license && showNotificationToolbar && (<LicenseNotificationBar closeNotificationToolbar={() => setShowNotificationToolbar(false)} />)}

                <Toolbar className="p-0 min-h-48">
                    {config.navbar.display && (
                        <Hidden lgUp>
                            <NavbarMobileToggleButton className="w-40 h-40 p-0 mx-0 sm:mx-8" />
                        </Hidden>
                    )}

                    <div className="xs:text-20 sm:text-24 m-16">{header && header.title}</div>

                    <div className="flex flex-1">
                    </div>
                    <div className="flex items-center px-16">
                        {user.isLoggedIn && <LicenseType />}
                        <LanguageSwitcher />
                        <FullScreenToggle />
                        |
                        {!user.isLoggedIn &&
                            <Tooltip title={t('toolbar.login')} placement="bottom">
                                <IconButton
                                    aria-label="login"
                                    className={clsx('w-40 h-40 text-white', props.className)}
                                    to={() => "/auth/login?redirect=" + redirectPath()}
                                    component={Link}>
                                    <Icon>login</Icon>
                                </IconButton>
                            </Tooltip>
                        }
                        {!user.isLoggedIn &&
                            <Tooltip title={t('toolbar.register')} placement="bottom">
                                <IconButton aria-label="Register" className={clsx('w-40 h-40 text-white', props.className)} to="/auth/register" component={Link}>
                                    <Icon>person_add</Icon>
                                </IconButton>
                            </Tooltip>
                        }
                        {user.isLoggedIn && <UserMenu />}
                    </div>
                </Toolbar>
            </AppBar>
        </ThemeProvider>
        {/* <Dialog open={showNewVersionDialog} onClose={() => setShowNewVersionDialog(false)}>
            <DialogTitle>Saiwa 2.0</DialogTitle>
            <DialogContent>
                <Box className='flex flex-col' >
                    <Typography variant='body1' className='font-bold'>
                        You are visiting <span className='text-green'>Saiwa 2.0 - Alpha version</span>. Many new features and improvements are added here that we hope you find them useful.
                    </Typography>

                    <br />

                    <Typography variant='body1' className='font-bold'>
                        Until we finalize our new version, please kindly consider the followings:
                    </Typography>

                    <br />

                    <ol className='font-bold list-decimal ml-32'>
                        <li>if you got any unexpected errors, please kindly {user.isLoggedIn ? <a href={`${process.env.PUBLIC_URL}/ticket/new-ticket`}>leave us a ticket</a> : <a href='https://saiwa.ai/contact'>contact us</a>}</li>
                        <li> if you like to continue using <a href='https://old.saiwa.ai/app'>Saiwa 1.0</a>, you still have complete access.</li>
                    </ol>
                    <br />
                    <Box className='flex flex-row justify-center'>
                        <Button variant='contained' color='primary' className='mr-8' onClick={() => window.open('https://old.saiwa.ai/app','_self')}>
                            Redirect to Saiwa 1.0
                        </Button>
                        <Button variant='contained' color='secondary' onClick={handleDontShowVersionDialogAgain}>Do not show this message again</Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog> */}
    </>
    );
}

export default React.memo(ToolbarLayout1);
